    import "../InputCus.css";
    import { useRef } from "react";


    function InputCus({ type, name, id, text, onChange, note,className, value, width, disabled = false }) {
        const pInput = useRef();
        return (
            <div className={`form-item ${className}`} style={{ width: width }}>
                <p ref={pInput} className={value || type == "date" ? "formLabel formTop" : "formLabel"}>{text}</p>
                {/*<p ref={pInput} className="formLabel">{text}</p>*/}
                {type === "textarea" ?
                    <textarea
                    style={{"height":"150px"}}
                    value={value}
                        disabled={disabled}
                        onChange={(e) => {
                            onChange(e)
                        }}
                        onBlur={(e) => {
                            e.target.value === "" && type != "date" && pInput.current.classList.remove("formTop")
                        }} onFocus={() => {
                            pInput.current.classList.add("formTop")
                        }} name={name} id={id} className="form-style w-100" autoComplete="off" ></textarea> :
                    <input value={value}
                        disabled={disabled}
                        onChange={(e) => {
                            onChange(e)
                        }}
                        onBlur={(e) => {
                            e.target.value === "" && type != "date" && pInput.current.classList.remove("formTop")
                        }} onFocus={() => {
                            pInput.current.classList.add("formTop")
                        }} type={type} name={name} id={id} className="form-style w-100" autoComplete="off" />
                }
                {note&& <p className="note p-1 ps-3">{note}</p>}
            </div>
        )
    }

    export default InputCus;
